const Vue = require('vue');

Vue.config.ignoredElements = require('utils/vue-ignore')();

// @sweetwater/vue-components
const currency = require('@sweetwater/vue-components/components/currency.vue').default;
const dropdown = require('@sweetwater/vue-components/components/dropdown/dropdown.vue').default;
const dropdownBack = require('@sweetwater/vue-components/components/dropdown/dropdown-back.vue').default;
const dropdownCol = require('@sweetwater/vue-components/components/dropdown/dropdown-col.vue').default;
const dropdownContent = require('@sweetwater/vue-components/components/dropdown/dropdown-content.vue').default;
const dropdownGroup = require('@sweetwater/vue-components/components/dropdown/dropdown-group.vue').default;
const dropdownHeadline = require('@sweetwater/vue-components/components/dropdown/dropdown-headline.vue').default;
const dropdownIcon = require('@sweetwater/vue-components/components/dropdown/dropdown-icon.vue').default;
const dropdownItem = require('@sweetwater/vue-components/components/dropdown/dropdown-item.vue').default;
const dropdownItemPhone = require('@sweetwater/vue-components/components/dropdown/dropdown-item-phone.vue').default;
const dropdownRow = require('@sweetwater/vue-components/components/dropdown/dropdown-row.vue').default;
const dropdownToggle = require('@sweetwater/vue-components/components/dropdown/dropdown-toggle.vue').default;
const dropdownToggleButton = require('@sweetwater/vue-components/components/dropdown/dropdown-toggle-button.vue').default;
const dynamicContainer = require('@sweetwater/vue-components/components/dynamic-container.vue').default;
const modal = require('@sweetwater/vue-components/components/modal.vue').default;
const phone = require('@sweetwater/vue-components/components/phone.vue').default;
const preloader = require('@sweetwater/vue-components/components/preloader.vue').default;
const svgIcon = require('@sweetwater/vue-components/components/svg-icon.vue').default;
const typeahead = require('@sweetwater/vue-components/components/typeahead.vue').default;
const vCol = require('@sweetwater/vue-components/components/v-col.vue').default;
const vRow = require('@sweetwater/vue-components/components/v-row.vue').default;

// local components
const ratingStars = require('./components/RatingStars.vue').default;
const adaMenu = require('./components/header/ada-menu.vue').default;
const cartIcon = require('./components/header/cart-icon.vue').default;
const headerAccountsMenu = require('./components/header/header-accounts-menu.vue').default;
const headerContactMenu = require('./components/header/header-contact-menu.vue').default;
const item = require('./components/item.vue').default;
const recentlyViewedItems = require('./components/recently-viewed-items.vue').default;
const siteBackButton = require('./components/header/site-back-button.vue').default;
const videoModal = require('./components/video-modal.vue').default;
const whyBuyBanner = require('./components/header/why-buy-banner.vue').default;

Vue.component('RatingStars', ratingStars);
Vue.component('AdaMenu', adaMenu);
Vue.component('CartIcon', cartIcon);
Vue.component('Currency', currency);
Vue.component('Dropdown', dropdown);
Vue.component('DropdownBack', dropdownBack);
Vue.component('DropdownCol', dropdownCol);
Vue.component('DropdownContent', dropdownContent);
Vue.component('DropdownGroup', dropdownGroup);
Vue.component('DropdownHeadline', dropdownHeadline);
Vue.component('DropdownIcon', dropdownIcon);
Vue.component('DropdownItem', dropdownItem);
Vue.component('DropdownItemPhone', dropdownItemPhone);
Vue.component('DropdownRow', dropdownRow);
Vue.component('DropdownToggle', dropdownToggle);
Vue.component('DropdownToggleButton', dropdownToggleButton);
Vue.component('DynamicContainer', dynamicContainer);
Vue.component('HeaderAccountsMenu', headerAccountsMenu);
Vue.component('HeaderContactMenu', headerContactMenu);
Vue.component('Item', item);
Vue.component('Modal', modal);
Vue.component('Phone', phone);
Vue.component('Preloader', preloader);
Vue.component('RecentlyViewedItems', recentlyViewedItems);
Vue.component('SiteBackButton', siteBackButton);
Vue.component('SvgIcon', svgIcon);
Vue.component('Typeahead', typeahead);
Vue.component('VCol', vCol);
Vue.component('VRow', vRow);
Vue.component('VideoModal', videoModal);
Vue.component('WhyBuyBanner', whyBuyBanner);

module.exports = Vue;
